import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  L10N_LOCALE,
  L10nLocale,
  L10nTranslatePipe,
  L10nTranslationService
} from 'angular-l10n';
import { throwError } from "rxjs";
import { oase_config } from '../../environments/environment';
import { APIConfigService } from "../api.config.service";
import { AngularMaterial2Module } from "../app.module.material";
import { AuthService } from '../shared/auth.service';
import { ErrorHelper } from "../shared/error.helper";
import { LoggerService } from '../shared/logger.service';
import { Kernantwort } from '../shared/response/kernantwort.model';

const PATH_FILE = 'app/unprotected/signin.component.ts';
const BACKEND_PATH_PREFIX = 'signin/';
@Component({
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
  standalone: true, imports: [AngularMaterial2Module, L10nTranslatePipe, CommonModule, ReactiveFormsModule]

})
export class SigninComponent implements OnInit {

  signinForm: FormGroup;
  error = false;
  errorMessage = '';
  fehler: Kernantwort = null;
  fehler_keineappid: string = "";
  appVersion: string = oase_config.appversion;
  @ViewChild('password', { static: true }) password;
  isRequestRunning: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly fb: FormBuilder,
    public authService: AuthService,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    public translation: L10nTranslationService,
    public apiConfigService: APIConfigService,
    public title: Title,
    private readonly _logger: LoggerService) {
    // Set document title.
    this.title.setTitle(this.getTitle());
    this._logger.log(PATH_FILE + ' - isAuth: ' + this.isAuth());
    if (this.isAuth()) {
      this.router.navigate(['/home']);
    }
  }

  ngOnInit(): any {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.signinForm = this.fb.group({
        user: [{ value: '', disabled: false }, Validators.required],
        password: [{ value: '', disabled: false }, Validators.required]
      });
    });
  }

  onSignin() {
    this.isRequestRunning = true;
    let auth_token: string = null;
    this._logger.debug(PATH_FILE + ' - onSignin vor authService.signinUser');
    this.authService.signinUser(this.signinForm.value).subscribe({
      next: (data) => {
        auth_token = data.authtoken
      },
      error: (err) => {
        this.fehler = ErrorHelper.handleError(err, 'Fehler bei Anmeldung', this._logger, this.translation);
        this.isRequestRunning = false;
        return throwError(() => new Error(this.fehler.message));
      },
      complete: () => {
        this.authService.storeJwToken(auth_token, new Date().getTime());
        this.authService.logTokenInfos(PATH_FILE + ' - signinUser');
        this.isRequestRunning = false;
        this.router.navigate(['/home']);
      }
    });
  }

  isButtonDisabled() {
    return !this.signinForm.valid || this.isRequestRunning;
  }

  isAuth() {
    return this.authService.isAuthenticated();
  }

  getTitle() {
    return this.translation.translate('login.title') + ' - ' + this.translation.translate('project.title');
  }

  showPassword(event: any): void {
    // https://developer.mozilla.org/en-US/docs/Web/Events/mousedown
    this.password.nativeElement.type = "text";
  }

  hidePassword(event: any): void {
    // https://developer.mozilla.org/en-US/docs/Web/Events/mouseup
    // https://developer.mozilla.org/en-US/docs/Web/Events/mouseout
    this.password.nativeElement.type = "password";
  }
}
